<template>
  <button
    class="app_button"
    :class="[
      `app_button_${type}`,
      `app_button_size_${size}`
    ]"
    type="button"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot>Button</slot>
  </button>
</template>

<script>
export default {
  name: 'ViewButton',
  props: {
    type: {
      type: String,
      default: 'yellow',
      validator: (value) => ['yellow', 'blue'].includes(value)
    },
    size: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'large', 'small', 'dark'].includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(event) {
      if (this.disabled) return
      this.$emit('click', event)
    }
  }
}
</script>

<style scoped lang="scss">
.app_button {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px;
  border: none;
  border-radius: 8px;
  background-repeat: no-repeat;
  background-position: center bottom;
  font-size: 18px;
  font-weight: 900;
  line-height: normal;
  letter-spacing: -0.02em;
  cursor: pointer;
  transition: filter 0.2s ease, transform 0.2s ease;

  &:hover:not(:disabled) {
    filter: brightness(0.98);
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: not-allowed;
    /* opacity: 0.7; */
  }
}

.app_button_size_default {
  width: 217px;
  height: 61px;
  background-size: 149px 30px;
}

.app_button_size_large {
  flex: 0 0 194px;
  width: 194px;
  height: 66px;
  padding: 0 16px;
  font-size: 24px;
  font-weight: 700;
  background-size: 100% auto;
}

.app_button_size_small {
  flex: 0 0 164px;
  width: 164px;
  height: 48px;
  padding: 0 16px;
  font-size: 16px;
  font-weight: 700;
  background-size: 100% auto;
}

.app_button_size_dark {
  flex: 0 0 164px;
  width: 164px;
  height: 41px;
  padding: 0 16px;
  font-size: 16px;
  font-weight: 700;
  background-size: 100% auto;
}

.app_button_yellow {
  color: #333333;
}

.app_button_yellow {
  background-image: url('@/assets/images/VehicleHistory/shine.png');
  background-color: #F5C200;
}

/* .app_button_yellow.app_button_size_large,
.app_button_yellow.app_button_size_small {
  background-image: url('@/assets/images/bottom-light-bg.png'), linear-gradient(270deg, #ffcc00 0%, #fcd42d 99%);
  background-color: #ffcc00;
}

.app_button_yellow.app_button_size_dark {
  background-image:url('@/assets/images/bottom-light-bg.png'), linear-gradient(270deg, #ffcc00 0%, #fcd42d 99%);
  background-color: #FFCC00;
} */

.app_button_blue {
  background-image: url('@/assets/images/forBusiness/blue_luminescence.png');
  background-color: #003EB0;
  color: #ffffff;
}
</style>
